<template>


    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">采购记录</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">订单号</div>
                    <div class="header-item">食材名称</div>
                    <div class="header-item">采购数量</div>
                    <div class="header-item">单价(元)</div>

                    <div class="header-item">总金额(元)</div>
                    <div class="header-item">供应商</div>
                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in paginatedPurchaseList" :key="index">
                            <div class="body-item">{{ item.orderNo }}</div>
                            <div class="body-item">{{ item.materialName }}</div>
                            <div class="body-item">{{ item.num }}{{ item.unit }}</div>
                            <div class="body-item"> {{ item.unitPrice }}</div>
                            <div class="body-item"> {{ item.totalPrice }}</div>
                            <div class="body-item"> {{ item.supplier }}</div>

                        </div>
                        <div class="empty-tip" v-if="paginatedPurchaseList.length === 0">
                            暂无信息
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>

</template>

<script>
import { getRecord } from "@/api/procurement";

export default {
    name: 'PurchaseManagement',
    data() {
        return {
            // 搜索表单
            searchForm: {
                orderNo: '',        // 采购单号
                materialName: '',   // 食材名称
                supplier: '',       // 供应商
            },
            // 原始采购单列表（所有数据）
            purchaseList: [],
            // 食材列表
            materialList: [],
            // 供应商列表
            supplierList: [],
            // 统计数据
            pendingCount: 0,
            approvedCount: 0,
            completedCount: 0,
            monthTotalAmount: 0,
            // 分页参数
            currentPage: 1,
            pageSize: 10,
            // 弹窗状态
            purchaseDialogVisible: false,
            detailDialogVisible: false,
            approvalDialogVisible: false,
            // 详情表单数据
            detailForm: {},
            // 审批表单数据
            approvalForm: {
                id: '',
                purchaseNo: '',
                materialName: '',
                purchaseNum: 0,
                unit: '',
                totalPrice: 0,
                approvalResult: 'approved',
                approvalOpinion: ''
            }
        }
    },
    computed: {
        // 第一步：筛选数据（纯计算，无副作用）
        filteredPurchaseList() {
            // 复制原始数据
            let filtered = [...this.purchaseList];

            // 采购单号筛选
            if (this.searchForm.orderNo) {
                filtered = filtered.filter(item =>
                    item.orderNo && item.orderNo.includes(this.searchForm.orderNo)
                );
            }

            // 食材名称筛选
            if (this.searchForm.materialName) {
                filtered = filtered.filter(item =>
                    item.materialName && item.materialName.includes(this.searchForm.materialName)
                );
            }

            // 供应商筛选
            if (this.searchForm.supplier) {
                filtered = filtered.filter(item =>
                    item.supplier && item.supplier.includes(this.searchForm.supplier)
                );
            }

            // 只返回筛选结果，不修改任何状态
            return filtered;
        },

        // 第二步：获取筛选后的总数量（纯计算）
        filteredTotalCount() {
            return this.filteredPurchaseList.length;
        },

        // 第三步：分页处理（纯计算）
        paginatedPurchaseList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.filteredPurchaseList.slice(start, end);
        }
    },
    watch: {
        // 监听搜索条件变化，重置页码
        searchForm: {
            deep: true,
            handler() {
                this.currentPage = 1;
            }
        }
    },
    mounted() {
        // 页面加载时获取数据
        this.getPurchaseList();
    },
    methods: {
        // 获取采购单列表
        getPurchaseList() {
            // 显示加载状态
            const loading = this.$loading({
                lock: true,
                text: '正在加载数据...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            // 调用接口获取数据
            getRecord().then(response => {
                console.log('接口返回数据：', response);
                this.purchaseList = response.data || [];
                loading.close();
            }).catch(error => {
                console.error('获取采购单列表失败：', error);
                this.$message.error('获取数据失败，请稍后重试');
                this.purchaseList = [];
                loading.close();
            });
        },

        // 格式化类别显示
        formatType(type) {
            const typeMap = {
                'vegetable': '蔬菜类',
                'meat': '肉类',
                'seafood': '水产类',
                'grainOil': '粮油类',
                'driedGoods': '干货类'
            };
            return typeMap[type] || type;
        },

        // 重置搜索
        resetSearch() {
            this.searchForm = {
                orderNo: '',
                materialName: '',
                supplier: '',
            };
            this.currentPage = 1;
            // 可选：重新从接口获取数据
            // this.getPurchaseList();
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1; // 重置页码为1
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        // 表格行点击事件
        handleRowClick(row) {
            this.$refs.tableRef.toggleRowSelection(row);
        }
    }
}
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>